import isEmpty from 'lodash/isEmpty';
import arraySort from 'array-sort';

import { filterPagesForGivenGroupAndPurpose } from './filterGroupsPurposesPages';

export function generateGroupOptions(groups) {
  const options = groups.map(group => ({
    value: group.groupId,
    label: group.groupName,
  }));
  return arraySort(options, 'label');
}

export function generatePurposeOptions(group, purposes) {
  const options = isEmpty(group)
    ? []
    : purposes[group.groupName].map(purpose => ({
      value: purpose,
      label: purpose,
    }));
  return arraySort(options, 'label');
}

export function generatePageOptions(group, purpose, pages) {
  const options = !isEmpty(group) && purpose
    ? filterPagesForGivenGroupAndPurpose(group.groupId, purpose, pages).map(
      page => ({
        value: page.pageId,
        label: page.name,
      }),
    )
    : [];
  return arraySort(options, 'label');
}
